<template>
  <v-flex xs12 id="index">
    <bread-crumbs :links="breadsCrumbs"></bread-crumbs>
    <v-layout row wrap>
      <v-flex v-if="!isSP" md4>
        <v-flex xs12 class="round" style="text-align:left;margin:0px 16px 1px 16px;background:#fff;padding:16px;">
          <h3 style="padding-bottom:10px;">カラログを投稿しよう！</h3>
          <p>辛いものを食べたらカラログを投稿しよう！<br>
            カラログは食べた辛いものの感想や、いいね！と思った激辛に関する情報を気軽に投稿できる機能です。<br>
            ぜひ、あなたのカライイネを教えてください。
          </p>
          <p style="text-align:center">
            <v-btn color="primary" dark large @click="$refs.foodView.onReview()">
              この食品に投稿
            </v-btn>
            <v-btn color="primary" outline dark large :to="{name: 'reviewPostSearchFood'}">
              別の食品に投稿
            </v-btn> 
          </p>
        </v-flex>
      </v-flex>
      <v-flex md8 xs12>
        <div v-if="!isLoading">
          <food-view
            ref="foodView"
            @onMessage='onMessage'
            :food="select.food" :imageurls="select.imageurls"
          ></food-view>
          <!-- 関連食品 -->
          <v-flex v-if="select.food" xs12 style="margin-top:16px">
            <food-card-query
              :query="{category: select.food.category, categoryname: select.food.categoryname}"
              :without="select.id"
            ></food-card-query>
          </v-flex>
          <!-- /関連食品 -->
        </div>
        <div v-show="isLoading" style="text-align:center;height:400x;padding-top:150px;margin-bottom:150px">
          <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
        </div>
      </v-flex>
    </v-layout>
    <v-flex v-if="isSP" xs12 class="round" style="text-align:left;margin:16px 0;background:#fff;padding:16px;">
      <h2 style="padding-bottom:10px;">カラログを投稿しよう！</h2>
      <p>辛いものを食べたらカラログを投稿しよう！<br>
        カラログは食べた辛いものの感想や、いいね！と思った激辛に関する情報を気軽に投稿できる機能です。<br>
        ぜひ、あなたのカライイネを教えてください。
      </p>
      <p style="text-align:center">
        <v-btn color="primary" dark block large @click="$refs.foodView.onReview()">
          この食品に投稿
        </v-btn>
        <v-btn color="primary" outline block dark large :to="{name: 'reviewPostSearchFood'}">
          別の食品に投稿
        </v-btn> 
      </p>
    </v-flex>
  </v-flex>
</template>

<script>
import BreadCrumbs from '@/components/common/BreadCrumbs.vue'
import FoodView from '@/components/card/FoodView.vue'
import FoodCardQuery from '@/components/card/FoodCardQuery.vue'
import { db } from '@/main'
import getImageUrl from '@/assets/js/getImageUrl.js'
export default {
  name: 'FoodDetail',
  data () {
    return {
      isLoading: false,
      select: {
        id: undefined,
        food: undefined,
        imageurls: []
      },
      breadsCrumbs: [],
      breadsCrumbsForSearch: [{name: 'home', meta: {pageName: 'トップ'}}, {name: 'searchFood', meta: {pageName: '食品一覧'}}]
    }
  },
  computed: {
    headerTitle () {
      if (this.select.food) {
        return this.select.food.name + 'の商品情報・口コミ・SNSの評判'
      }
      return ''
    },
    headerDescription () {
      if (this.select.food) {
        if (this.select.food.description) {
          return this.select.food.description
        }
      }
      return '辛いもの好きによる' + this.select.food.name + 'の商品情報・口コミ・SNSの評判です。激辛・旨辛ライフの参考にしよう！！'
    },
    isSP () {
      if (this.displaySize==='xs' || this.displaySize==='sm') return true
      return false
    },
    displaySize () {
      return this.$vuetify.breakpoint.name
    }
  },
  filters: {
  },
  watch: {
    '$route' () {
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      window.scrollTo(0, 0)
      this.select.imageurls = []
      this.select.id = this.$route.params.id
      this.select.food = this.$store.getters.getFoodById(this.select.id)
      if (this.select.food) {
        this.select.imageurls = this.select.food.imageurls
      } else {
        await this.getDetail()
      }
      this.$emit('updateHead')
      this.detailBread()
    },
    detailBread () {
      let breads = this.breadsCrumbsForSearch.concat()
      breads.push({
        name: 'searchFoodDetail',
        params: {id: this.select.id},
        meta: {pageName: `${this.select.food.name}`}
      })
      this.breadsCrumbs = breads
    },
    async getDetail () {
      this.isLoading = true
      let response = await db.collection('food').doc(this.select.id).get()
      this.select.food = response.data()
      this.select.food.id = this.select.id
      this.getImageUrl()
      this.isLoading = false
    },
    getImageUrl () {
      if (this.select.food.images === undefined) return
      if (this.select.food.images && this.select.food.images.length > 0) {
        this.select.food.images.forEach(path => {
          let url = getImageUrl.get('food', this.select.food.id, path)
          this.select.imageurls.push(url)
          this.select.imageurls.sort(function (a, b) {
            if( a < b ) return -1
            if( a > b ) return 1
            return 0
          })
        })
      }
      else {
        this.select.imageurls.push(getImageUrl.get('food', this.select.food.id, undefined))
      }
    },
    onMessage (obj) {
      this.$emit('onMessage', obj)
    }
  },
  components: {
    BreadCrumbs,
    FoodView,
    FoodCardQuery
  },
  head: {
    title () {
      if (this.headerTitle !== '') {
        return {
          inner: this.headerTitle,
          separator: ' ',
          complement: 'カライイネ 激辛・旨辛グルメ特化のSNS！'
        }
      }
    },
    meta () {
      if (this.headerTitle !== '') {
        return [
          {name: 'description', content: this.headerDescription}
        ]
      }
    }
  }
}
</script>

<style scoped>
  #index{
    min-height: 90vh;
    text-align:center;
  }
</style>